module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Bedriftskurs"},"en":{"title":"Company courses"}}')
  delete Component.options._Ctor
}
